import { useLocation } from 'react-router-dom'
const Acknowledge = () => {
    const location = useLocation();
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4rem',height:'80vh',justifyContent:'center' }}>
            <div className="anim" style={{ display: 'flex', transition: 'all 1s ease-out', width: '11rem' }}>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                    <circle className="path circle" fill="none" stroke="#73AF55" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                    <polyline className="path check" fill="none" stroke="#73AF55" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                </svg>
            </div>
            <span style={{ fontSize: '1.5rem' }}>Your paper <b>{location.state && location.state.abfp}</b> submitted successfully</span>
        </div>
    )
}

export default Acknowledge